import React, {useMemo} from "react";
import {Context} from "@hotwired/stimulus";
import {useForm} from "react-hook-form";
import {valibotResolver} from "@hookform/resolvers/valibot";
import {ReactWrapperController} from "@root/server/client/esweb/src/lib/stimulus/ReactWrapperController.ts";
import {FormServerErrors} from "@root/server/client/esweb/src/pages/web/shared/form-server-errors.tsx";
import {useFormSubmission} from "@root/server/client/esweb/src/lib/hooks/useFormSubmission.ts";
import {Turnstile} from '@marsidev/react-turnstile'

import {
    EmailLinkLoginFormProps,
    EmailLinkLoginFormValues,
    EmailLinkLoginSchema,
    flow_email_form_name
} from "./flow_email.shared.tsx";

import {t} from "@root/server/client/esweb/src/lib/i18n.ts";
import {ContinueSubmitButton} from "@root/server/client/esweb/src/pages/web/shared/continue-submit-button.tsx";
import {FormInput} from "@root/server/client/esweb/components/ui/rhf/FormInput.tsx";
import {Form} from "@root/server/client/esweb/components/ui/form.tsx";
import {RhfCheckbox} from "@root/server/client/esweb/components/ui/rhf/RhfCheckbox.tsx";


export const name = flow_email_form_name;

export default class extends ReactWrapperController {
    constructor(context: Context) {
        super(context, (props) => <FlowEmailForm {...props} />);
    }
}


function FlowEmailForm({submitUrl, initialEmail}: EmailLinkLoginFormProps) {
    const defaultValues = useMemo<EmailLinkLoginFormValues>(() => ({
        email: initialEmail ?? "",
        remember_me: false
    }), [initialEmail]);

    const form = useForm({
        resolver: valibotResolver(EmailLinkLoginSchema),
        defaultValues,
        mode: "onTouched",
        reValidateMode: "onChange",
    });

    const {control, handleSubmit} = form;

    const {execute, isSubmitting, canSubmit, serverErrors, turnstileProps} = useFormSubmission({submitUrl, requireTurnstile: true});

    return (
        <Form {...form}>
            <form className="space-y-6" onSubmit={handleSubmit(execute)} data-lazy-content-target="content">
                <div className="space-y-4">
                    {/* FIXED: Props passed directly */}
                    <FormInput
                        autoFocus={true}
                        control={control}
                        name="email"
                        placeholder={t({cs: "vas@email.cz", en: 'your@email.com'})}
                    />

                    <RhfCheckbox
                        control={control}
                        name="remember_me"
                        label={t({
                            cs: 'Pamatovat si mě na tomto zařízení',
                            en: 'Remember me on this device'
                        })}
                    />
                </div>

                <div className="text-slate-500 text-sm">
                    {t({
                        cs: <>Pokračováním souhlasíte s <a href="/web/static/terms" className="underline">Podmínkami použivání a zásadami ochrany osobních údajů</a></>,
                        en: <>By continuing you agree to <a href="/web/static/terms" className="underline">Terms of Service and Privacy Notice</a></>
                    })}
                </div>

                <Turnstile {...turnstileProps} />

                <FormServerErrors errors={serverErrors} />

                <ContinueSubmitButton {...{isSubmitting, canSubmit}}/>
            </form>
        </Form>
    );
}